<template>
  <div>
    <tooltip>
      <div data-node-content class="cursor-pointer text-gray-500 italic">
        {{ node.content ?? "" }}
      </div>
      <template #content>
        <div>{{ tooltipText }}</div>
      </template>
    </tooltip>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { EditorNode, OptionContext } from "@/models/TextEditor";

const props = defineProps<{
  node: EditorNode;
}>();
const tooltipText = computed(
  () => (props.node?.context as OptionContext)?.tooltip
);
</script>
